/* tslint:disable */
/* eslint-disable */
/**
 * Dataland Backend API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ExportJobProgressState } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
/**
 * DataExportControllerApi - axios parameter creator
 */
export const DataExportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Given the exportJobId download the corresponding file. Files can only be downloaded once.
         * @summary Export data exportJobId provided.
         * @param {string} exportJobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCompanyAssociatedDataById: async (exportJobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportJobId' is not null or undefined
            assertParamExists('exportCompanyAssociatedDataById', 'exportJobId', exportJobId)
            const localVarPath = `/export/{exportJobId}/download`
                .replace(`{${"exportJobId"}}`, encodeURIComponent(String(exportJobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/octet-stream,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check state of export job.
         * @summary Get information about export job being done.
         * @param {string} exportJobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportJobState: async (exportJobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportJobId' is not null or undefined
            assertParamExists('getExportJobState', 'exportJobId', exportJobId)
            const localVarPath = `/export/{exportJobId}/state`
                .replace(`{${"exportJobId"}}`, encodeURIComponent(String(exportJobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataExportControllerApi - functional programming interface
 */
export const DataExportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataExportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Given the exportJobId download the corresponding file. Files can only be downloaded once.
         * @summary Export data exportJobId provided.
         * @param {string} exportJobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportCompanyAssociatedDataById(exportJobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportCompanyAssociatedDataById(exportJobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataExportControllerApi.exportCompanyAssociatedDataById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check state of export job.
         * @summary Get information about export job being done.
         * @param {string} exportJobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExportJobState(exportJobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportJobProgressState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExportJobState(exportJobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataExportControllerApi.getExportJobState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataExportControllerApi - factory interface
 */
export const DataExportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataExportControllerApiFp(configuration)
    return {
        /**
         * Given the exportJobId download the corresponding file. Files can only be downloaded once.
         * @summary Export data exportJobId provided.
         * @param {string} exportJobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCompanyAssociatedDataById(exportJobId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportCompanyAssociatedDataById(exportJobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Check state of export job.
         * @summary Get information about export job being done.
         * @param {string} exportJobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportJobState(exportJobId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobProgressState> {
            return localVarFp.getExportJobState(exportJobId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataExportControllerApi - interface
 */
export interface DataExportControllerApiInterface {
    /**
     * Given the exportJobId download the corresponding file. Files can only be downloaded once.
     * @summary Export data exportJobId provided.
     * @param {string} exportJobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportCompanyAssociatedDataById(exportJobId: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Check state of export job.
     * @summary Get information about export job being done.
     * @param {string} exportJobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExportJobState(exportJobId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobProgressState>;

}

/**
 * DataExportControllerApi - object-oriented interface
 */
export class DataExportControllerApi extends BaseAPI implements DataExportControllerApiInterface {
    /**
     * Given the exportJobId download the corresponding file. Files can only be downloaded once.
     * @summary Export data exportJobId provided.
     * @param {string} exportJobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public exportCompanyAssociatedDataById(exportJobId: string, options?: RawAxiosRequestConfig) {
        return DataExportControllerApiFp(this.configuration).exportCompanyAssociatedDataById(exportJobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check state of export job.
     * @summary Get information about export job being done.
     * @param {string} exportJobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getExportJobState(exportJobId: string, options?: RawAxiosRequestConfig) {
        return DataExportControllerApiFp(this.configuration).getExportJobState(exportJobId, options).then((request) => request(this.axios, this.basePath));
    }
}

